// extracted by mini-css-extract-plugin
export var phone = "_36-0";